import {MqttDeviceConnectProvide} from "./mqtt";
import {config} from "../config";
import {WebError} from "@hybird/core/error";
import {deviceError} from "@hybird/device/deviceError";

class WebscoketDeviceConnectProvide extends MqttDeviceConnectProvide {
  _connectForce = true;

  async close(force = true) {
    await super.close();
    return new Promise((resolve, reject) => {
      try {
        if (this._client?.readyState === 1) {
          this._client.close(0, "正常退出");
        }
        resolve();
      } catch (error) {
        reject(WebError.code(deviceError.CLOSE_ERROR, { error }));
      }
    });
  }

  /**
   * @type{ WebSocket }
   * @private
   */
  _client;

  connect({connectForce = true, onConnect, onConnected, onReconnect, onDisconnect, onDisconnected, onError} = {}) {
    this._connectForce = connectForce;

    return new Promise((resolve, reject) => {
      if (this._client && this._client.readyState === 1) {
        resolve();
        return;
      }

      console.log(config.mqtt);
      const param = Object.assign({}, config.mqtt);

      if (!param.clientId || !param.password || !param.username) {
        throw new Error("连接参数参数错误");
      }

      if (param.url.startsWith("nettys")) {
        param.url = param.url.replace("nettys", "wss");
      } else {
        param.url = param.url.replace("netty", "ws");
      }

      onConnect?.call(this);
      this._client = new WebSocket(param.url);
      this._client.onopen = event => {
        const fromData = {
          header: {
            password: param.password,
            clientId: param.clientId,
            username: param.username,
            type: 0
          },
          body: {}
        };

        this._client.send(JSON.stringify(fromData));

        config.onConnect?.call(this);
        onConnected?.call(this);
        resolve(this);
      };

      this._client.onmessage = (event) => {
        const replyData = JSON.parse(event.data.toString());
        const topic = replyData.topic;
        console.log("websocket onmessage", event.data);

        switch (replyData.type) {
          case 0:
            break;
          case 1:
            break;
          case 2: {
            const payload = replyData.data;
            console.log("message", topic, payload);
            this._onMessage(topic, payload);
            break;
          }
          case 3:
            break;
          case 4:
            break;
          case 5:
            break;
        }
      };

      this._client.onerror = ((error) => {
        config.onError?.call(this, error);
        onError?.call(this);
      });

      this._client.onclose = ((error) => {
        config.onReconnect?.call(this, error);
        onDisconnect?.call(this);

        if (this._connectForce) {
          this.connect({connectForce, onConnect, onConnected, onReconnect, onError}).then((client) => {
            resolve(client);
          });
        } else {
          reject(WebError.code(deviceError.CONNECT_ILLEGAL_ARGUMENT, {
            error: error
          }));
        }
      });
    });
  }

  get connected() {
    return this._client != null ? this._client.readyState === 1 : false;
  }

  _subscribe(topic, {success, message, complete, fail} = {}) {
    return new Promise((resolve, reject) => {
      let fromData = {header: {topic: topic, type: 4}, body: {}};
      this._client.send(JSON.stringify(fromData));
      resolve();
    });
  }

  _unsubscribe(topic, {success, error, complete, fail} = {}) {
    return new Promise((resolve, reject) => {
      return new Promise((resolve, reject) => {
        let fromData = {header: {topic: topic, type: 5}, body: {}};
        this._client.send(JSON.stringify(fromData));
        resolve();
      });
    });
  }

  async _publish(topic, params, {id, success, complete, fail} = {}) {
    const records = {
      id: id ? id : this.id,
      version: "1.0",
      params: params ?? {},
      time: Date.now()
    };

    return new Promise((resolve, reject) => {
      console.log(this.toString(), "publish", topic, JSON.stringify(records));

      const fromData = {header: {topic: topic, type: 2}, body: records};
      this._client.send(JSON.stringify(fromData));
      resolve();
    });
  }

  isSupport(connectType, config) {
    return config && config.mqtt.url && config.mqtt.url.startsWith("netty") && super.isSupport(connectType);
  }
}


export {WebscoketDeviceConnectProvide};